import { useState, useEffect, useCallback } from 'react';
import './ScrollNavigator.css';

export default function ScrollNavigator() {
  const [progress,  setProgress]  = useState(0);
  const [visible,   setVisible]   = useState(false);
  const [direction, setDirection] = useState('down');
  const [animating, setAnimating] = useState(false);

  const RADIUS        = 22;
  const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

  const update = useCallback(() => {
    const scrollY = window.scrollY;
    const docH    = document.documentElement.scrollHeight - window.innerHeight;
    const pct     = docH > 0 ? Math.min(scrollY / docH, 1) : 0;

    setProgress(pct);
    setVisible(scrollY > 80);
    setDirection(pct < 0.5 ? 'down' : 'up');
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', update, { passive: true });
    update();
    return () => window.removeEventListener('scroll', update);
  }, [update]);

  const handleClick = () => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => setAnimating(false), 700);

    if (direction === 'down') {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const offset = CIRCUMFERENCE - progress * CIRCUMFERENCE;

  return (
    <div className={`scroll-nav ${visible ? 'scroll-nav--visible' : ''}`}>
      <button
        className={`scroll-nav__btn ${animating ? 'scroll-nav__btn--pulse' : ''}`}
        onClick={handleClick}
        aria-label={direction === 'down' ? 'Scroll to bottom' : 'Scroll to top'}
      >
        <svg
          className="scroll-nav__ring"
          width="52"
          height="52"
          viewBox="0 0 56 56"
          aria-hidden="true"
        >
          <circle
            className="scroll-nav__track"
            cx="28" cy="28" r={RADIUS}
            fill="none"
            strokeWidth="2.5"
          />
          <circle
            className="scroll-nav__arc"
            cx="28" cy="28" r={RADIUS}
            fill="none"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={offset}
            transform="rotate(-90 28 28)"
          />
        </svg>

        <span
          className={`scroll-nav__arrow ${direction === 'up' ? 'scroll-nav__arrow--up' : ''}`}
          aria-hidden="true"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </span>
      </button>

      <div className="scroll-nav__tooltip" aria-hidden="true">
        {direction === 'down' ? 'Scroll to bottom' : 'Back to top'}
      </div>
    </div>
  );
}
